<template>
  <div class="splashscreen">
    <div class="splashscreen-wrapper">
      <span class="splashscreen-text">
        Trwa ładowanie danych&hellip;
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'splashscreen',
  mounted () {
    this.$http.post('/users/items').then(() => {
      let nextRoute = this.$route.params.nextRoute;
      let nextQuery = this.$route.query;

      if (!nextRoute || nextRoute === '/wczytywanie') {
        nextRoute = '/';
        nextQuery = {};
      }

      setTimeout(() => {
        this.$router.push({ path: nextRoute, query: nextQuery });
      }, 1000);
    }).catch(error => {
      console.log(error);

      setTimeout(() => {
        this.$router.push({ name: 'Logowanie' });
      }, 1000);
    });
  }
}
</script>
